import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['form', 'submitButton']


  connect() {
    this.formDirty = false
    this.formTarget.addEventListener('change', event => {
      this.formChanged(event)
    })

    this.submitButtonTarget.addEventListener('click', event => {
      this.formSubmitted(event)
    })

    const elements = document.getElementsByClassName('ignore-form-alert')

    Array.from(elements).forEach(el => {
      el.addEventListener('click', event => this.formSubmitted(event))
    })

    window.addEventListener('beforeunload', event => {
      if (!this.formDirty) return

      if (window.navigator.userAgent.includes('Chrome')) {
        event.returnValue = 'Are you sure you want to leave?'
      }
      this.leavingPage(event)
    })

    const fc = this.formChanged.bind(this)

    $(function() {
      [$('select.select2')].flat().forEach(function(s) {
        $(s).on('select2:select', function (_e) {
          fc()
        })
        $(s).on('select2:unselect', function (_e) {
          fc()
        })
        $(s).on('select2:clear', function (_e) {
          fc()
        })
      })
    })
  }

  formChanged() {
    this.formDirty = true;
  }

  leavingPage(event) {
    if (this.formDirty) {
      event.preventDefault();
    }
  }

  formSubmitted() {
    this.formDirty = false
  }
}
